import { defineComponent } from 'vue'

import { useAppStore } from '@/stores/app'

export default defineComponent({
  name: 'LangMixin',
  computed: {
    language(): string {
      return useAppStore().language
    },
  },
  methods: {
    getValueByLang(input: Record<string, string> | string): string {
      if (typeof input !== 'object') {
        return input
      }
      if (Object.keys(input).includes(this.language)) {
        return input[this.language]
      }

      return input[Object.keys(input)[0]]
    },
    getAttributeNameByLang(attributeName: string, attributeDefinition: any): string {
      if (
        attributeDefinition &&
        attributeDefinition.trans &&
        attributeDefinition.trans[this.language]
      ) {
        return attributeDefinition.trans[this.language]
      }

      return attributeName
    },
  },
})
